export default __webpack_public_path__ + "static/media/Add-Contact-MERGED.d82ab725.png";